import { api } from '@creditsights/api-ui-web';
import { SearchFilingsPayload } from '../../hooks/documents/useFetchFilings';
import { CompanyFilingsDto } from '../dtos/companyFilings/companyFilings.dto';
import { CompanyFilingsTypeDto } from '../dtos/companyFilings/companyFilingsType.dto';
import { ListResult } from '../dtos/listResult';

export const COMPANY_FILINGS_MODULE_V1_URI = '/document-upload/v1/company-document';

export const fetchCompanyFilings = async ({
  companyId,
  ...payload
}: SearchFilingsPayload & { companyId: string }): Promise<ListResult<CompanyFilingsDto>> => {
  const { data } = await api.get(`${COMPANY_FILINGS_MODULE_V1_URI}/${companyId}`, { params: payload });

  return {
    results: data.results,
    totalResults: data.total,
  };
};

export const fetchCompanyFilingsTypes = async (): Promise<CompanyFilingsTypeDto[]> => {
  const { data } = await api.get(`${COMPANY_FILINGS_MODULE_V1_URI}/types`);
  return data;
};

export const buildLink = (data: CompanyFilingsDto): string => `/api/common/v1/media/document/${data.guid}`;
